import { faSpinner } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import withStyles from "isomorphic-style-loader/lib/withStyles";
import moment from "moment";
import React from "react";
import { withRouter } from "react-router-dom";
import ReactTable from "react-table";
import { Button, Col, Container, Input, Row } from "reactstrap";
import { handleRequestError } from "../../../utils/helpers";
import {
  infoNotification,
  successNotification
} from "../../../utils/notifications";
import {
  saveConciliacionExtractedCharges,
  uploadConciliacionCsvFile
} from "../../actions/billing";
import MexicanCurrency from "../common/currency";
import DatePicker from "../common/DatePicker";
import s from "./styles.scss";

interface Props {
  history: any;
  match: any;
}

interface State {
  fecha: String;
  cargos: any[];
  saving: boolean;
  loading: boolean;
  file: Blob;
}

class ConciliacionCargaArchivos extends React.Component<Props, State> {
  state = {
    fecha: null,
    cargos: [],
    saving: false,
    loading: false,
    file: null
  };

  componentDidMount() {}

  handleSubmit = async () => {
    this.setState({ saving: true });
    infoNotification("Guardando...");

    try {
      const { data: procesoId } = await saveConciliacionExtractedCharges({
        fecha: this.state.fecha,
        cargos: this.state.cargos
      });

      await uploadConciliacionCsvFile(this.state.file, "cargos.csv", procesoId);

      successNotification("Datos guardados correctamente");
      this.clearFields();
    } catch (error) {
      handleRequestError(error);
      this.setState({ loading: false, saving: false });
    }
  };

  clearFields = () => {
    this.setState({
      fecha: null,
      cargos: [],
      saving: false,
      loading: false,
      file: null
    });
  };

  columns = [
    {
      Header: "Fecha",
      accessor: "fecha",
      className: "text-center"
    },
    {
      Header: "Proceso",
      accessor: "proceso",
      className: "text-center"
    },
    {
      Header: "Operación",
      accessor: "operacion",
      className: "text-center"
    },
    {
      Header: "Referencia",
      accessor: "referencia",
      className: "text-center"
    },
    {
      Header: "Afiliación",
      accessor: "afiliacion",
      className: "text-center"
    },
    {
      Header: "Forma de pago",
      accessor: "formaPago",
      className: "text-center"
    },
    {
      Header: "Tipo tarjeta",
      accessor: "tipoTarjeta",
      className: "text-center"
    },
    {
      Header: "Importe",
      className: "text-right",
      Cell: row => {
        return <MexicanCurrency quantity={row.original.importe} />;
      }
    }
  ];

  render() {
    return (
      <Container className="w-100 px-0 pt-2">
        <Row className="primaryTitle m-0 mb-2 mt-4">
          <Col xs="10">
            <p className="m-0">Fecha del archivo</p>
          </Col>
        </Row>

        <Row>
          <Col xs={4} className="pr-0 pt-2">
            <DatePicker
              label="Fecha del archivo"
              name="fechaInicioVigencia"
              id="fechaInicioVigencia"
              selected={this.state.fecha}
              onChange={e => {
                const date = moment(e).format("YYYY-MM-DD");
                this.setState({ fecha: date });
              }}
              errors={[]}
              disabled={this.state.loading || this.state.saving}
            />
          </Col>
          <Col></Col>
          <Col xs="2" className="mt-4">
            <Button
              className={`${s.buttonMarginTop} ${s.primaryButton} mr-5`}
              onClick={() => {
                this.handleSubmit();
              }}
              size="md"
              block
              disabled={
                (this.state.cargos || []).length <= 0 ||
                !this.state.fecha ||
                this.state.loading ||
                this.state.saving
              }
            >
              {this.state.saving ? (
                <>
                  <FontAwesomeIcon icon={faSpinner} pulse /> Guardando...
                </>
              ) : (
                "Guardar"
              )}
            </Button>
          </Col>
        </Row>

        {/* ------------------------------------------------------- */}
        <Row className="primaryTitle m-0 mb-2 mt-4">
          <Col xs="10">
            <p className="m-0">Cargos</p>
          </Col>
        </Row>
        <Container className="w-100 px-0 pt-2">
          <ReactTable
            data={this.state.cargos}
            columns={this.columns}
            className="-striped -highlight"
            sortable={false}
            showPagination={true}
            pageSize={(this.state.cargos || []).length ? 20 : 10}
            loading={this.state.loading}
          />
          {!this.state.saving && (
            <div>
              <p className={`my-2`}>Cargar desde csv</p>
              <Row className={`p-0 m-0`}>
                <Col xs={4} className="p-0 m-0">
                  <Input
                    type="file"
                    id="pricesFile"
                    accept=".csv"
                    onChange={ev => {
                      ev.preventDefault();
                      const file = ev.target.files[0];
                      const blob = new Blob([file], { type: "text/plain" });

                      this.setState({ loading: true, cargos: [], file });
                      infoNotification("Extrayendo cargos de archivo csv");

                      const fileReader = new FileReader();
                      fileReader.onload = event => {
                        const fileText = event.target.result;
                        const lines = fileText.split("\n");
                        const items = [];

                        for (let i = 1; i < lines.length; i++) {
                          if (lines[i].length > 0) {
                            const lineParts = lines[i]
                              .replaceAll("\r", "")
                              .split(",");
                            items.push({
                              clubId: null,
                              clubNombre: "SN",
                              fecha: lineParts[0],
                              hora: null,
                              proceso: lineParts[1],
                              operacion: lineParts[2],
                              referencia: lineParts[3],
                              afiliacion: lineParts[4],
                              formaPago: lineParts[5],
                              tipoTarjeta: lineParts[6],
                              importe: lineParts[7]
                                .replaceAll("$", "")
                                .replaceAll(",", "")
                                .replaceAll('"', ""),
                              estatus: lineParts[8]
                            });
                          }
                        }

                        this.setState({ cargos: [...items], loading: false });
                      };
                      fileReader.readAsText(blob);

                      /* uploadConciliacionCsvFile(file, "cargos.csv")
                        .then(({ data }) => {
                          console.info(data);
                          this.setState({ cargos: [...data] });
                          successNotification("Cargos extraídos correctamente");
                        })
                        .catch(handleRequestError); */
                    }}
                  />
                </Col>
                <Col xs={4}></Col>
                <Col xs={4} className="text-right"></Col>
              </Row>
            </div>
          )}
        </Container>

        <div className="text-right pr-0 pt-2 mt-4 mb-4"></div>
      </Container>
    );
  }
}

export default withRouter(withStyles(s)(ConciliacionCargaArchivos));
